module.exports = __webpack_public_path__ + "img/logo-comprodonto.bd54fe5e.png";